import { MigrationInteractor, MigrationRequest, MigrationStructRequest } from "../../Coordinator/Migration/MigrationInteractor"

export class MigrationViewModel {
	private interactor: MigrationInteractor;

	constructor() {
		this.interactor = new MigrationInteractor();
	}

	public getMigrations(page: number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.getMigrations(page).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}